<script setup>
import { onBeforeUnmount, ref } from 'vue'

// This component is a very tiny wrapper around the native <video> element.
// It adds explicit destroyal of the player resource in the browser.
// This forces quick cleanup and avoids getting above the `WebMediaPlayer` limit in Chromium browsers.
// Also, in case a reference to the media player is kept in memory somewhere, this forces a resources release.

defineProps({
  item: Object,
})

const emit = defineEmits(['videoElement'])

const videoElement = ref(null)

onMounted(() => {
  emit('videoElement', videoElement.value)
})

onBeforeUnmount(() => {
  if (videoElement.value) {
    videoElement.value.pause()
    videoElement.value.src = ''
    videoElement.value.load()
    videoElement.value.remove()
    videoElement.value.srcObject = null
    videoElement.value = null
  }
})
</script>

<template>
  <video ref="videoElement" />
</template>
